import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { User } from '@app/_models';
import { Dealer } from '@app/_models/dealer';
import { AccountService } from '@app/_services';
import { DealerService } from '@app/_services/dealer-service';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent implements OnInit, OnDestroy {
    account: User;
    dealer: Dealer;
    dealerCount: number = null;
    private destroy$ = new Subject<void>();

    constructor(
        private accountService: AccountService,
        private dealerService: DealerService
    ) {
        this.account = this.accountService.userValue;
    }

    ngOnInit(): void {
        if (this.account?.role === 'Admin' || this.account?.role === 'Employee') {
            this.dealerService.getAll()
                .pipe(takeUntil(this.destroy$))
                .subscribe(dealers => {
                    this.dealerCount = dealers?.length || 0;
                });
        }

        if (this.account?.dealerId) {
            this.dealerService.getByDealerId(this.account.dealerId)
                .pipe(takeUntil(this.destroy$))
                .subscribe(dealer => {
                    this.dealer = dealer;
                });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
